




























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAllocation } from '@/interfaces/allocation';

@Component
export default class AllocationCard extends Vue {
    @Prop({ required: true })
    private readonly allocation!: IAllocation;

    private isopen: boolean = false;
    containerClick() {
        this.$emit('copy-reference', this.allocation.reference);
    }
    toggleSubcardDisplay() {
        this.isopen = !this.isopen;
    }
    computedColor(teusCount: number, teusTotal: number, styleParameter: string){
        if (teusTotal === 0 && teusCount === 0)
            return styleParameter + "-green";

        const ratio = teusCount / teusTotal;
        
        if (ratio < 0.33)
            return styleParameter + "-green";
        else if (ratio >= 0.33 && ratio < 0.66)
            return styleParameter + "-orange";
        else
            return styleParameter + "-red";
    }
}
